angular.module('picmonicng').component('affiliatePortalComponent', {
  templateUrl: '/templates/app/pages/affiliate-portal/affiliate-portal.html',
  bindings: {},
  controller: [
    'UserService',
    'User',
    'MarketOptionsConfig',
    'affiliateResource',
    '$filter',
    'toaster',
    '$stateParams',
    '$http',
    '$anchorScroll',
    function (
      UserService,
      User,
      MarketOptionsConfig,
      affiliateResource,
      $filter,
      toaster,
      $stateParams,
      $http,
      $anchorScroll
    ) {
      const promotionalFrom = new Date(1763874000000);
      const promotionalTo = new Date(1765008000000);
      const now = new Date().getTime();
      const amazonGiftCardAmount = '$5';
      const promoAmazonGiftCardAmount = '<del>$5</del> $10';

      const ctrl = this;
      ctrl.now = now;
      ctrl.userAgent = navigator.userAgent;
      ctrl.UserService = UserService;
      ctrl.user_count = window.pls_config.user_count;
      ctrl.redeem_email = UserService.user.email;
      ctrl.isAdmin = !!$stateParams.is_admin;
      ctrl.market_school = MarketOptionsConfig.getMarketById(UserService.user.lead).school_name;
      ctrl.showPromotional = now >= promotionalFrom && now <= promotionalTo;

      ctrl.navItemSelected = 'sharelink';
      ctrl.navItems = [
        { id: 'sharelink', name: 'Share Your Link' },
        { id: 'howitworks', name: 'How It Works' },
        { id: 'yourstats', name: 'Your Stats' },
        { id: 'yourreferralhistory', name: 'Your Referral History' },
        { id: 'extrabonuses', name: 'Extra Bonuses' },
        { id: 'itseasytogetstarted', name: 'Get Started' },
        { id: 'downloadableresources', name: 'Downloadable Resources' },
        { id: 'hashtaglibrary', name: 'Hashtag Library' },
        { id: 'talkingpoints', name: 'Talking Points' },
        {
          id: 'learnmoreaboutpicmonic',
          name: 'Learn More About Picmonic',
        },
        { id: 'gethelp', name: 'Get Help' },
      ];

      ctrl.updateTotalPaidAndEarned = function (data) {
        ctrl.totalPaid = 0;
        ctrl.totalEarned = 0;
        angular.forEach(data.history, function (quarter) {
          ctrl.totalPaid += parseInt(quarter.paid_user, 10);
          ctrl.totalEarned += parseFloat(quarter.earned);
        });
      };

      if (ctrl.isAdmin) {
        ctrl.referrals = {};
        $http.get('/api/v3/admin/users/' + $stateParams.id + '/referrals').then(function (referrals) {
          ctrl.referrals = referrals.data;
          ctrl.updateNextBonus(referrals.data.friends);
        });
        ctrl.affiliate = {};
        $http.get('/api/v3/admin/users/' + $stateParams.id + '/affiliate_portal').then(function (data) {
          ctrl.affiliate = data.data;
          ctrl.updateTotalPaidAndEarned(data.data);
        });
        ctrl.hide_share = true;
      } else {
        ctrl.referrals = User.get({ resource: 'referrals' });
        ctrl.referrals.$promise.then(function (referrals) {
          ctrl.updateNextBonus(referrals.friends);
        });
        ctrl.affiliate = affiliateResource.get();
        ctrl.affiliate.$promise.then(function (data) {
          ctrl.updateTotalPaidAndEarned(data);
        });
      }

      ctrl.redeemRewards = function () {
        if (
          ctrl.referrals.total_redeemable_balance &&
          !ctrl.loading_redeem &&
          confirm('Are you sure you want to request your rewards be sent to ' + ctrl.redeem_email + '?')
        ) {
          ctrl.loading_redeem = true;
          User.post(
            {
              resource: 'referrals',
              resource_id: 'redeem',
              email: ctrl.redeem_email,
            },
            function () {
              ctrl.referrals = User.get({
                resource: 'referrals',
              });
              ctrl.referrals.$promise.then(function () {
                toaster.success('Reward successfully requested! Check your inbox within 24 hours.');
                ctrl.loading_redeem = false;
              });
            },
            function (response) {
              ctrl.loading_redeem = false;
              toaster.error(response.data.message);
            }
          );
        }
      };

      ctrl.updateNextBonus = function (friends) {
        if (friends < 2) {
          ctrl.nextBonus = 2 - friends;
        } else if (friends < 5) {
          ctrl.nextBonus = 5 - friends;
        } else if (friends < 10) {
          ctrl.nextBonus = 10 - friends;
        } else if (friends < 20) {
          ctrl.nextBonus = 20 - friends;
        } else if (friends < 30) {
          ctrl.nextBonus = 30 - friends;
        } else if (friends < 50) {
          ctrl.nextBonus = 50 - friends;
        } else if (friends < 70) {
          ctrl.nextBonus = 70 - friends;
        } else if (friends < 100) {
          ctrl.nextBonus = 100 - friends;
        }
      };

      $anchorScroll.yOffset = 16;

      ctrl.selectAnchor = function (anchor) {
        ctrl.navItemSelected = anchor;
        $anchorScroll(anchor);
      };

      ctrl.base_asset_url = window.pls_config.base_asset_url.substring(
        window.pls_config.base_asset_url.indexOf('/cloud_data')
      );

      if (!UserService.user.tos_accepted) {
        UserService.showTOSModal();
      }

      /**
       * Retrieves the Amazon Gift Card dollar amount
       */
      ctrl.getAmazonGiftCardAmount = function () {
        if (ctrl.showPromotional) {
          return promoAmazonGiftCardAmount;
        }

        return amazonGiftCardAmount;
      };

      ctrl.discountAmount = function () {
        return Math.max(30, ctrl.affiliate.user_discount_percent);
      };
    },
  ],
});
